import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-chair-workouts': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_free_month_chair_workouts~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_free_month_chair_workouts'
					),
			},
		},
	},
]

export default config
